import { OfferWithNft } from "@/app/(components)/Application/User/OffersTable/types";
import { useMemo } from "react";
import useAcceptCollectionOffer from "./useAcceptCollectionOffer";
import useAcceptNftOffer from "./useAcceptNftOffer";

export default function useAcceptOffer(offer: OfferWithNft) {
  const useSettleAcceptOffer = useMemo(() => {
    if (offer.isForCollection) {
      return useAcceptCollectionOffer;
    }

    return useAcceptNftOffer;
  }, [offer.isForCollection]);

  return useSettleAcceptOffer(offer);
}
